<template>
    <div>
        <h1 style="font-size: 24px; color: black;">灵动岛管理</h1>
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="showDetails('新增灵动岛')">添加灵动岛</el-button>
        </div>
        <h1>
            <el-table border max-height="550"
                      :data="liveActivities">
                <el-table-column label="编号" prop="id" align="center"></el-table-column>
                <el-table-column label="名称" prop="name" align="center"></el-table-column>
                <el-table-column  label="封面图" width="120px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="排序" align="center">
                    <template slot-scope="scope">
                        <el-input-number size="small" :min="0" v-model="scope.row.ranking"
                                         @change="updateLiveActivity(scope.row,0)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state === true" class="sub-sub" type="success" @click="updateLiveActivity(scope.row,1)">
                            已启用
                        </el-button>
                        <el-button v-if="scope.row.state === false" class="sub-sub" type="danger" @click="updateLiveActivity(scope.row,1)">
                            已禁用
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑灵动岛',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="子类" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" @click="liveManage(scope.row)">管理模板</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="liveActivityEditForm" :label-width="labelWidth">
                    <el-form-item label="名称:">
                        <el-input style="width: 300px" type="text" v-model="liveActivityEditForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="封面:" :label-width="labelWidth">
                        <el-upload
                                :headers="headers"
                                class="avatar-uploader"
                                :action="uploadURL"
                                :show-file-list="false"
                                :on-success="handleImageSuccess"
                                :before-upload="function (file) { return beforeAvatarUpload(file)}"
                                @click="uploadImage">
                            <img v-if="liveActivityEditForm.image" :src="VUE_APP_CDN_URL+liveActivityEditForm.image" class="avatar">
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="排序 :" :label-width="labelWidth">
                        <el-input-number :min="0" v-model="liveActivityEditForm.ranking"></el-input-number>
                    </el-form-item>
                    <el-form-item label="状态 :" :label-width="labelWidth">
                        <el-radio v-model="liveActivityEditForm.state" :label="false">不显示</el-radio>
                        <el-radio v-model="liveActivityEditForm.state" :label="true">显示</el-radio>
                    </el-form-item>

                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmForm">确 定</el-button>
                        <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
    </div>
</template>

<script>
    import {upload,
        searchLiveActivity,
        saveLiveActivity,
        deleteLiveActivity
    } from "@/http/iosApi";

    export default {
        name: "BlockRule",
        data() {
            return {
                liveActivities: [],
                VUE_APP_IOS_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                labelWidth: '150px',
                dialogVisible: false,
                dialogTitle: '',
                liveActivityEditForm: {},
                queryData: {},
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods: {
            search() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                this.queryData.parentId = null;
                searchLiveActivity(this.queryData).then(resp => {
                    this.liveActivities = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            handleImageSuccess(response){
                this.liveActivityEditForm.image=response.info;
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            updateLiveActivity(row,position) {
                this.liveActivityEditForm = {
                    "id": row.id,
                    "name": row.name,
                    "image": row.image,
                    "ranking": row.ranking,
                    "state": position === 0 ? row.state : !row.state
                };
                this.$confirm('此操作将更改该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    saveLiveActivity(this.liveActivityEditForm).then(resp => {
                        if (resp.data.status === 0) {
                            this.search();
                        }
                    })
                }).catch(() => {
                    this.search();
                });
            },
            showDetails(title, row) {
                this.liveActivityEditForm = {
                    "id": 0,
                    "name": '',
                    "image": '',
                    "ranking": 0,
                    "state": false
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if (row) {
                    this.liveActivityEditForm = {
                        "id": row.id,
                        "name": row.name,
                        "image": row.image,
                        "ranking": row.ranking,
                        "state": row.state
                    };
                }
            },
            confirmForm() {
                let _message = '';
                if (this.liveActivityEditForm.name === '') {
                    _message = '请输入名称'
                }
                if (_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveLiveActivity(this.liveActivityEditForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLiveActivity(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search()
                        }
                    });
                }).catch(() => {
                })
            },
            liveManage(liveActivity) {
                this.$store.commit('addLiveActivity', liveActivity);
                this.$router.push({path: '/secondLiveActivity'});
            }
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
        },
        mounted() {
            this.VUE_APP_IOS_URL=process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }

    }
</script>

<style scoped>

</style>